const { produce } = require("immer");
const permissions = require("./permissions");

const init = {
  uid: null,
  name: null,
  type: "admin",
  groupUid: null,
  permissions: Object.keys(permissions).reduce((acc, k) => {
    acc[k] = true;
    return acc;
  }, {})
}

const setPermission = type => {
  if(type) {
    return Object.entries(permissions)
      .filter(([k, t]) => t === type)
      .reduce((acc, [k, t]) => acc[k] = false)
  } else return permissions
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_profileForm":
      return produce(state, draft => {
        if(action.form.permissions) {
          Object.assign(draft, action.form, {
            permissions: Object.assign(draft.permissions, action.form.permissions)
          });
        } else {
          let { uid, name, type, groupUid } = action.form;
          Object.assign(draft, { uid, name, type, groupUid,
            permissions: setPermission(type)
          });
        }
      });

    case "UPDATE_profileForm":
      return produce(state, draft => {
        Object.assign(draft, action.form, action.form.permissions ? {
          permissions: Object.assign(draft.permissions, action.form.permissions)
        } : null);
      });

    case "RESET_profileForm":
      return init;

    default:
      return state;
  }
}
